export enum BroadcastMessageTypeEnum {
    None = 0,
    Announcement = 1,
    Alert = 2,
    Information = 3,
    Confirmation = 4,
    Reminder = 5,
    Notification = 6,
    Promotion = 7,
    Transaction = 8,
    SurveyFeedback = 9,
    Welcome = 10,
    StatusUpdate = 11,
    ErrorWarning = 12,
    Request = 13,
    Invitation = 14,
    Acknowledgement = 15,
    Emergency = 16,
    BirthdayGreetings = 17,
    NewsArticle = 18,
    SystemUpdate = 19,
}
